'use strict';
var React = require('react');
var assetsHelper = require('../helper/assetsHelper');
var i18nHelper = require('../helper/i18n');

var SaveAlert = React.createClass({

    propTypes: {
        onCloseCopiedAlert: React.PropTypes.func
    },

    render: function () {
        return (
            <div className='pop-alert-cover' >
                <div className='pop-alert'>
                    <img className="close" src={assetsHelper.getAsset('close2.png')} onClick={this.props.onCloseCopiedAlert}/>
                    <p className="content">{i18nHelper.get('COPIED_PAGE_LINK')}</p>
                    <div className="btns">
                        <input className="save" type='button' onClick={this.props.onCloseCopiedAlert} value={i18nHelper.get('BUTTON_SURE')}/>

                    </div>
                </div>
            </div>
        );
    },

    componentDidUpdate: function() {

    },

    componentDidMount: function() {

    },


});

module.exports = SaveAlert;



// WEBPACK FOOTER //
// ./src/views/PageLinkCopiedAlert.jsx